// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1zYnc","buttonsContainer":"styles_buttonsContainer__ZAajZ","colorsButton":"styles_colorsButton__2vqnO"};